import './Navigation.scss';

import React, { Component } from 'react';
import Logger from '@KrashidBuilt/common/utils/logger';

import { UserContext } from '../../ctx';
import pkg from '../../../package.json';
import { ROUTE_MAP } from '../../routes';
import { NavItem, SupportModal } from '../../components';
import images from '../../assets/images';
import { getDesktopAppInstallLink } from '../../utils/desktop';
import { DownloadIcon } from '@radix-ui/react-icons';
import { NavigationDropdownMenu } from '@fifth-gear-tech/common-components/dist/components';
import { Colors } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DASHBOARD_WEB_APP, SPEEDFOLDER_WEB_APP } from '../../constants';

const logger = new Logger('Navigation');

class Navigation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            loading: false,
        };
    }

    load = () => {
        this.setState({ loading: true }, async () => {
            let link = null;
            try {
                link = await getDesktopAppInstallLink();
            } catch (error) {
                logger.error('unable to get link:', link);
            }

            this.setState({ loaded: true, loading: false, link });
        });
    }

    componentDidMount() {
        const { loaded, loading } = this.state;

        if (!loaded && !loading) {
            this.load();
        }
    }

    app = [
        {
            label: 'Labels',
            to: ROUTE_MAP.LABELS,
            isLoggedIn: true,
        },
        {
            label: 'Settings',
            to: ROUTE_MAP.SETTINGS.TEMPLATES,
            isLoggedIn: true,
        }
    ];

    user = [
        {
            label: 'Login',
            to: ROUTE_MAP.LOGIN,
            isLoggedIn: false,
        }
    ];

    build = (n) => {
        const { user } = this.context;
        if ((!n.isLoggedIn && !user) || (n.isLoggedIn && user)) {
            return (
                <NavItem key={n.to} to={n.to} label={n.label} />
            );
        }
    }


    render() {
        logger.extra({ state: this.state, context: this.context, props: this.props });
        const { user } = this.context;
        const { link } = this.state;

        return (
            <div className={'Navigation'}>
                <div className={'logo-container'}>
                    <a href={ROUTE_MAP.LABELS}>
                        <img
                            className="logo"
                            src={images.logos.SPEEDlabel}
                            alt="SPEEDlabel"
                        />
                    </a>
                    <div className={'version'}>{pkg.version}</div>
                </div>
                <div className={'filler'} />
                {/* <p className='Navigation'>Folder</p> */}
                <nav className={'app-links-container'}>
                    {this.app.map(this.build)}
                    <NavItem to={{ pathname: `${DASHBOARD_WEB_APP}/billing` }} label={'Invoices'} target="_blank" />
                    <NavItem to={{ pathname: 'SPEEDsnip://' }} label={'SPEEDsnip'} target="_blank" />
                    {user?.dId == 5 ? <NavItem to={{ pathname: SPEEDFOLDER_WEB_APP }} label={'SPEEDfolder'} target="_blank" /> : null}
                    <SupportModal />
                    {this.user.map(this.build)}
                </nav>
                {user &&
                    <NavigationDropdownMenu
                        colorTheme={Colors.Orange}
                        userCustomer={user.cName}
                        contents={null}
                        userFirstName={user.firstName}
                        userLastName={user.lastName}
                        accountCallback={() => {
                            window.open(DASHBOARD_WEB_APP, '_blank');
                        }}
                        supportCallback={() => {
                            window.open('mailto: support@fifthgeartech.com', '_blank');
                        }}
                        logoutCallback={() => {
                            this.props.history.push(ROUTE_MAP.LOGOUT);
                        }}
                        priorityContent={link ? {
                            label: 'Install New SpeedSnip',
                            right: <DownloadIcon />,
                            callback: () => {
                                const { link } = this.state;
                                window.open(link, '_blank');
                            }
                        } : null}
                    />
                }

            </div>

        );
    }
}

Navigation.contextType = UserContext;
Navigation.propTypes = {
    history: PropTypes.shape
};

export default withRouter(Navigation);